import React, {ReactNode} from 'react';
import {Link, useLocation} from 'react-router-dom';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import Logo from '../../../../shared/ui/icons/General/Logo';
import Box from '../../../../shared/ui/Box/Box';
import LogoOwner from '../../../../shared/ui/icons/General/LogoOwner';
import YandexCaptcha from '../../../../shared/ui/icons/YandexCaptcha';
import {AppUrls} from '../../../../shared/config/model/urls';

import LogoEn from '../../../../shared/ui/icons/General/LogoEn';

import styles from './Auth.module.scss';

interface IAuthWrapperProps {
    children: ReactNode,
}

const AuthWrapper: React.FC<IAuthWrapperProps> = ({children}) => {
    const location = useLocation();
    const isRegistrationPage = location.pathname.includes('/registration');

    return (
        <div className={styles.wrapper}>
            <div className={styles.logo}>
                <a href={AppUrls.MAIN_OVERSEER} target="_blank" rel="noopener noreferrer">
                    {!isTranslate() ? <Logo/> : <LogoEn/>}
                </a>
            </div>
            <Box className={cn(
                styles.container,
                isTranslate() ? styles.enContainer : styles.ruContainer,
            )}>
                {children}
            </Box>
            {
                isRegistrationPage && !isTranslate() && (
                    <div className={styles.containerLink}>
                        <YandexCaptcha />
                        <Link to={AppUrls.YANDEX_CAPTCHA_NOTICE} className={styles.yandexLink}>
                            Политика обработки данных
                        </Link>
                    </div>
                )
            }

            {
                !isTranslate() ?
                    <div className={styles.link}>
                        <a
                            href={AppUrls.MAIN_BROTHER}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.containerLogoBrothers}
                        >
                            <div className={styles.owner}>
                                <LogoOwner />
                                <span className={styles.name}>brotherhood.software</span>
                            </div>
                        </a>
                    </div>
                    : <></>
            }

        </div>
    );
};

export default AuthWrapper;